import { render, staticRenderFns } from "./DicCheckboxGroup.vue?vue&type=template&id=327df8bc&scoped=true&"
import script from "./DicCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./DicCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./DicCheckboxGroup.vue?vue&type=style&index=0&id=327df8bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327df8bc",
  null
  
)

export default component.exports